module.exports = "/fonts/iconsminds.ttf?3b6bac7a98e52945800cb481a6b93a2b";